import React from 'react';
import { MailIcon, ExternalLinkIcon } from 'lucide-react';
const credit = 'text-white/40 no-underline transition-colors hover:text-gold';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-navy py-16 border-t border-white/10" data-id="element-214" data-mp="36n3c3k2n3ksp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-215" data-mp="3ufjw405xtmun">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-216" data-mp="3990ijjp5eap">
          {/* Brand */}
          <div data-id="element-217" data-mp="3lem1g8he2roq">
            <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-218" data-mp="3levkfc40nykx">
              CaboDealFlow.com
            </h3>
            <p className="text-white/60 leading-relaxed" data-id="element-219" data-mp="3qc40n75ltsjj">
              Curated, data-driven real estate investment opportunities in Cabo
              San Lucas. Institutional-grade deal flow for sophisticated
              investors.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-220" data-mp="3labovo69tsmo">
            <h4 className="text-white font-semibold mb-4" data-id="element-221" data-mp="3l9sj15twaup0">Quick Links</h4>
            <ul className="space-y-2" data-id="element-222" data-mp="3gbilwpom1k0r">
              <li data-id="element-223" data-mp="3gck196cnssoa">
                <button onClick={() => scrollToSection('deals')} className="text-white/60 hover:text-gold transition-colors" data-id="element-224" data-mp="3v7q6hr3xkngk">
                  Current Deal Flow
                </button>
              </li>
              <li data-id="element-225" data-mp="81fppw8pas47">
                <button onClick={() => scrollToSection('spotlight')} className="text-white/60 hover:text-gold transition-colors" data-id="element-226" data-mp="80xik4ki2thi">
                  Spotlight Locations
                </button>
              </li>
              <li data-id="element-227" data-mp="cv1smwp2bhmt">
                <button onClick={() => scrollToSection('deal-report')} className="text-white/60 hover:text-gold transition-colors" data-id="element-228" data-mp="cuik26lay5lg">
                  Get Deal Report
                </button>
              </li>
              <li data-id="element-229" data-mp="tvw8ij57pjh1">
                <button onClick={() => scrollToSection('about')} className="text-white/60 hover:text-gold transition-colors" data-id="element-230" data-mp="twfmjorqrnps">
                  About
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-231" data-mp="18lk91i5kke3p">
            <h4 className="text-white font-semibold mb-4" data-id="element-232" data-mp="18m3rczz4t4i9">Contact</h4>
            <div className="space-y-4" data-id="element-233" data-mp="1ckt0uhh1u1wm">
              <a href="mailto:deals@cabodealflow.com" className="flex items-center text-white/60 hover:text-gold transition-colors" data-id="element-234" data-mp="1cnypxwpoh3sc">
                <MailIcon className="mr-2" size={18} data-id="element-235" data-mp="1mkjuyi1p6ew6" />
                deals@cabodealflow.com
              </a>
              <a href="https://cabocollection.com" target="_blank" rel="noopener noreferrer" className="flex items-center text-white/60 hover:text-gold transition-colors" data-id="element-236" data-mp="1rgsgcd6hn4bs">
                <ExternalLinkIcon className="mr-2" size={18} data-id="element-237" data-mp="2ag5fwt1bdghp" />
                CaboCollection.com
                <span className="ml-2 text-xs bg-gold/20 text-gold px-2 py-0.5 rounded" data-id="element-238" data-mp="25o5c2pi4i3fu">
                  Sister Site
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="border-t border-white/10 pt-8" data-id="element-239" data-mp="1wpjrkot3cecf">
          <p className="text-white/40 text-sm leading-relaxed mb-6" data-id="element-240" data-mp="2te9dcq7u9r3o">
            <strong className="text-white/60" data-id="element-241" data-mp="2pceavie697ob">Legal Disclaimer:</strong> This is
            not financial advice. All investment decisions should be made with
            your own due diligence. Past performance does not guarantee future
            results. Real estate investments carry risk, including loss of
            principal. Cabo Deal Flow is an informational resource and does not
            provide investment advice, legal counsel, or tax guidance. Consult
            with qualified professionals before making any investment decisions.
          </p>
          <p className="text-white/40 text-sm text-center" data-id="element-242" data-mp="2rug6bmx89urx">
            © {new Date().getFullYear()} Cabo Deal Flow. All rights reserved.
          </p>
          <div className="mt-4 flex flex-col items-center gap-1 text-center text-xs text-white/40 sm:flex-row sm:justify-center sm:gap-3" data-id="element-243" data-mp="2ivkwm0uz62jv">
            <span data-id="element-244" data-mp="2nunvt4o9xejx">
              <a href="https://adroimarketing.com/#/design/websites" target="_blank" rel="nofollow noopener noreferrer" className={credit} data-id="element-245" data-mp="2ns1ieoepc4ts">Website Design</a>,{' '}
              <a href="https://adroimarketing.com/#/marketing/local-seo" target="_blank" rel="nofollow noopener noreferrer" className={credit} data-id="element-246" data-mp="3fk0q2817gw29">Marketing</a> by{' '}
              <a href="https://adroimarketing.com/" target="_blank" rel="noopener noreferrer" className={credit} data-id="element-247" data-mp="36kdp1nce1s9q">Ad ROI Marketing</a>
            </span>
            <span aria-hidden="true" className="hidden opacity-50 sm:inline" data-id="element-248" data-mp="1q52lcck3kuvd">|</span>
            <span data-id="element-249" data-mp="1v69sqaibvs1i">
              <a href="https://adroimarketing.com/#/crm" target="_blank" rel="nofollow noopener noreferrer" className={credit} data-id="element-250" data-mp="1v6rzw26j3qo7">Sales Automation CRM</a> by{' '}
              <a href="https://1Dash.Pro" target="_blank" rel="noopener noreferrer" className={credit} data-id="element-251" data-mp="1innwvxmv4oae">1Dash.Pro</a>
            </span>
          </div>
        </div>
      </div>
    </footer>;
}